import { useSearchParams } from '@solidjs/router'
import { createMemo, Show, Suspense } from 'solid-js'
import AlertBag from '../../components/AlertBag'
import Loader from '../../components/Loader'
import ReplayPlayCanvas from '../../components/ReplayPlayCanvas'
import { StateType } from '../../lib/core/state/state_type.enum'
import parseIntOrNull from '../../lib/core/util/math/parseIntOrNull'
import createRedirectIfWrongStateTypeEffect from '../../rx/effect/createRedirectIfWrongStateTypeEffect'
import createGameRowResource from '../../rx/resource/createGameRowResource'
import { createLoadingSignal, registerLoadingResource } from '../../rx/signal/create_loading_signal'
import { createAlertBagStore, registerAlertBagResource } from '../../rx/store/AlertBag'
import type { Nullable } from '../../typescript'

type GameReplayPageSearchParams = {
  game_id: string
}

const componentStateType = StateType.Replay

const GameReplayPage = () => {
  const [searchParams] = useSearchParams<GameReplayPageSearchParams>()

  const loading = createLoadingSignal()
  const ab = createAlertBagStore()

  // const stateId = createValibotSafeParseMemo(ProfileIdSchema, () => parseIntOrNull(searchParams.game_id))
  const stateId = createMemo<Nullable<number>>((): Nullable<number> => parseIntOrNull(searchParams.game_id))

  // eslint-disable-next-line solid/reactivity
  const stateItemResource = createGameRowResource(stateId)
  const [stateRow] = stateItemResource
  createRedirectIfWrongStateTypeEffect(componentStateType, () => stateRow()?.data?.type, () => stateRow()?.data?.online?.id)

  registerLoadingResource(loading, stateItemResource)
  registerAlertBagResource(ab, stateItemResource)

  // createEffect(() => {
  //   const deleted_at = stateRow()?.deleted_at
  //   if (deleted_at) {
  //     setAlertBagWarning(ab, 'This map has been marked for deletion and will soon be removed by an automated garbage collection process.')
  //   } else {
  //     setAlertBagWarning(ab, null)
  //   }
  // })

  // TODO only ReplayPlayCanvas can be seen
  return (
    <div id="GameReplayPage">
      <Loader signal={loading} />
      <AlertBag store={ab} />
      <Suspense fallback={<div class="text-muted">Loading...</div>}>
        <Show when={stateRow()} children={(sr) => <ReplayPlayCanvas row={sr()} />} />
      </Suspense>
    </div>
  )
}

export default GameReplayPage